// Placeholder for Lucide ArrowLeft or use inline SVG
const ArrowLeftIcon = () => (
  <svg className='h-5 w-5 text-gray-600' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M10 19l-7-7m0 0l7-7m-7 7h18' />
  </svg>
)

interface SignupProgressProps {
  currentStep: number
  totalSteps: number
  onBack?: () => void
}

export function SignupProgress({ currentStep, totalSteps, onBack }: SignupProgressProps) {
  return (
    <div className='px-4 py-3'>
      <div className='flex items-center justify-between mb-4'>
        {onBack && currentStep >= 1 ? (
          <button
            onClick={onBack}
            className='p-1.5 rounded-full hover:bg-amber-200 transition-colors focus:outline-none focus:ring-2 focus:ring-amber-500'
            aria-label='뒤로가기'
          >
            <ArrowLeftIcon />
          </button>
        ) : (
          <div className='w-8 h-8' /> // Placeholder for alignment
        )}
        <div className={`text-sm text-amber-700 ${onBack && currentStep >= 1 ? '' : 'w-full text-center'}`}>
          {currentStep}/{totalSteps}
        </div>
        <div className='w-8 h-8' />
      </div>
      <div className='w-full h-1 bg-amber-200 rounded-full overflow-hidden'>
        <div
          className='h-full bg-amber-500 rounded-full transition-all duration-300'
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        ></div>
      </div>
    </div>
  )
}
